import React, { useState } from "react";
import { Card, FormGroup, Label, Button, Spinner } from "reactstrap";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import axios from "axios";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import {
  addCardAction,
  updateOrderAction,
} from "../../store/actions/orderAction";
import { FaCalculator, FaMoneyBillWave } from "react-icons/fa";
const stripePromise = loadStripe(
  "pk_live_51PODhQCZ2e3LaUkuh66yCcolizWqFckJUfV9A9fI9IGKNMPVfhvbBvZ0WVIhrB3ugCH4mRFHiBnqE0Et265hpDCe00oYUCvcgR"
);

const StripePayment = ({
  amount,
  tipAmountValue,
  setTipAmountValue,
  orderData,
  setModal,
  setTipAdded,
  dispatch,
  OrderId,
  onSdkError,
  currency,
  tip,
  tipType,
  paymentMethod,
}) => {
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [stripeFailedOnce, setStripeFailedOnce] = useState(false);

  const finalAmount = tipAmountValue;

  const handleSubmit = async (e, elements, stripe) => {
    e.preventDefault();
    setPaymentLoader(true);

    if (!stripe || !elements) {
      setPaymentLoader(false);
      return;
    }

    try {
      const cardElement = elements.getElement(CardNumberElement);
      const { token, error } = await stripe.createToken(cardElement);

      if (error) {
        throw new Error(error.message);
      }

      let body = {
        tokenId: token.id,
        restaurantID: orderData?.order[0]?.restaurantID,
        amount: Number(finalAmount),
        email: orderData?.user?.email,
        currency: "USD",
      };

      const res = await axios.post(
        "https://us-central1-menux1.cloudfunctions.net/app/payment",
        body
      );

      let { data } = res;
      await dispatch(addCardAction(body, orderData?.user?.uid));

      let obj = {
        ...orderData,
        customerID: orderData?.user?.id,
        totalAmount: finalAmount || 0,
        paymentMethod: "Stripe",
        status: "pending",
        customerName: orderData?.user?.name,
        paymentID: data?.charge?.id,
      };

      const payload = {
        OrderId,
        tip,
        tipType,
        totalAmount: obj?.totalAmount,
        customerID: obj?.customerID,
        customerName: obj?.customerName,
        paymentMethod,
        paymentID: obj?.paymentID,
      };

      await dispatch(
        updateOrderAction(payload, () => {
          setTipAdded(true);
          setTipAmountValue("");
        })
      );

      setModal(false);
    } catch (err) {
      toast.error(err?.message || "Payment failed");
      console.error(err?.response?.data?.message || err.message, "Error");

      if (elements) {
        elements.getElement(CardNumberElement)?.clear();
        elements.getElement(CardExpiryElement)?.clear();
        elements.getElement(CardCvcElement)?.clear();
      }
    } finally {
      setPaymentLoader(false);
    }
  };

  return (
    <Card
      className="px-3 mb-3 cart__payment_card-payment"
      style={{ width: "90%", maxWidth: "500px" }}
    >
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => {
            if (!stripe && !stripeFailedOnce) {
              setStripeFailedOnce(true);
              onSdkError && onSdkError();
            }

            return (
              <form onSubmit={(e) => handleSubmit(e, elements, stripe)}>
                <FormGroup>
                  <Label for="cardNumber">Card Number:</Label>
                  <div className="form-control mt-2 d-flex justify-content-between align-items-center shadow-sm">
                    <div style={{ flexBasis: "96%" }}>
                      <CardNumberElement
                        required
                        options={{
                          placeholder: "XXXX XXXX XXXX XXXX",
                          style: {
                            base: {
                              fontSize: "16px",
                            },
                            invalid: {
                              color: "#9e2146",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label for="expiryDate">Expiry Date:</Label>
                  <div className="form-control mt-2 d-flex justify-content-between align-items-center shadow-sm">
                    <div style={{ flexBasis: "96%" }}>
                      <CardExpiryElement
                        required
                        options={{
                          placeholder: "MM/YY",
                          style: {
                            base: {
                              fontSize: "16px",
                            },
                            invalid: {
                              color: "#9e2146",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label for="cvv">CVC/CVV:</Label>
                  <div className="form-control mt-2 d-flex justify-content-between align-items-center shadow-sm">
                    <div style={{ flexBasis: "96%" }}>
                      <CardCvcElement
                        required
                        options={{
                          placeholder: "...",
                          style: {
                            base: {
                              fontSize: "16px",
                            },
                            invalid: {
                              color: "#9e2146",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </FormGroup>

                {tipAmountValue > 0 && (
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="d-flex align-items-center fs--14 fw--500">
                      <FaMoneyBillWave className="mr-2 text-success" />
                      Total Order Amount:
                    </span>
                    <span className="fs--14">
                      {currency || "$"} {parseFloat(amount).toFixed(2)}
                    </span>
                  </div>
                )}

                <hr style={{ borderColor: "#444" }} />

                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="d-flex align-items-center fs--16 fw--600">
                    <FaCalculator className="mr-2 text-info" />
                    Tip Added:
                  </span>
                  <span className="fs--16 fw--600 text-primary">
                    {finalAmount ? finalAmount.toFixed(2) : "0.00"}{" "}
                    {currency || "USD"}{" "}
                  </span>
                </div>

                <Button
                  className="auth-button mt-2 py-3 btn btn-lg btn-block border border-none"
                  type="submit"
                  style={{ backgroundColor: "#f2ba36" }}
                  disabled={paymentLoader}
                >
                  {paymentLoader ? (
                    <Spinner size="sm" />
                  ) : (
                    <h4 className="mb-0">Pay with Stripe</h4>
                  )}
                </Button>
              </form>
            );
          }}
        </ElementsConsumer>
      </Elements>
    </Card>
  );
};

export default StripePayment;
